export default __webpack_public_path__ + "static/media/header-lab-icon.795d515c.svg";